/* eslint-disable */
import * as registry from '../registry.js'
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ quantity: NonNullable<unknown> }} Admin_External_Booking_Edit_Extra_Quantity_ItemInputs */

const en_admin_external_booking_edit_extra_quantity_item = /** @type {(inputs: Admin_External_Booking_Edit_Extra_Quantity_ItemInputs) => LocalizedString} */ (i) => {const quantityPlural = registry.plural("en", i?.quantity, {});
	if (quantityPlural == "one") return /** @type {LocalizedString} */ (`1 item`);
	if (quantityPlural == "other") return /** @type {LocalizedString} */ (`${i?.quantity} items`);
	return /** @type {LocalizedString} */ ("admin.external_booking_edit.extra_quantity_item");
};

/** @type {(inputs: Admin_External_Booking_Edit_Extra_Quantity_ItemInputs) => LocalizedString} */
const de_admin_external_booking_edit_extra_quantity_item = en_admin_external_booking_edit_extra_quantity_item;

/** @type {(inputs: Admin_External_Booking_Edit_Extra_Quantity_ItemInputs) => LocalizedString} */
const es_admin_external_booking_edit_extra_quantity_item = en_admin_external_booking_edit_extra_quantity_item;

/** @type {(inputs: Admin_External_Booking_Edit_Extra_Quantity_ItemInputs) => LocalizedString} */
const fr_admin_external_booking_edit_extra_quantity_item = en_admin_external_booking_edit_extra_quantity_item;

/** @type {(inputs: Admin_External_Booking_Edit_Extra_Quantity_ItemInputs) => LocalizedString} */
const it_admin_external_booking_edit_extra_quantity_item = en_admin_external_booking_edit_extra_quantity_item;

/** @type {(inputs: Admin_External_Booking_Edit_Extra_Quantity_ItemInputs) => LocalizedString} */
const pt_br2_admin_external_booking_edit_extra_quantity_item = en_admin_external_booking_edit_extra_quantity_item;

/** @type {(inputs: Admin_External_Booking_Edit_Extra_Quantity_ItemInputs) => LocalizedString} */
const pl_admin_external_booking_edit_extra_quantity_item = en_admin_external_booking_edit_extra_quantity_item;

/** @type {(inputs: Admin_External_Booking_Edit_Extra_Quantity_ItemInputs) => LocalizedString} */
const hu_admin_external_booking_edit_extra_quantity_item = en_admin_external_booking_edit_extra_quantity_item;

/** @type {(inputs: Admin_External_Booking_Edit_Extra_Quantity_ItemInputs) => LocalizedString} */
const ro_admin_external_booking_edit_extra_quantity_item = en_admin_external_booking_edit_extra_quantity_item;

/**
* | quantityPlural | output |
* | --- | --- |
* | "one" | "1 item" |
* | "other" | "{quantity} items" |
*
* @param {Admin_External_Booking_Edit_Extra_Quantity_ItemInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_external_booking_edit_extra_quantity_item = /** @type {((inputs: Admin_External_Booking_Edit_Extra_Quantity_ItemInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_External_Booking_Edit_Extra_Quantity_ItemInputs, { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_external_booking_edit_extra_quantity_item(inputs)
	if (locale === "de") return de_admin_external_booking_edit_extra_quantity_item(inputs)
	if (locale === "es") return es_admin_external_booking_edit_extra_quantity_item(inputs)
	if (locale === "fr") return fr_admin_external_booking_edit_extra_quantity_item(inputs)
	if (locale === "it") return it_admin_external_booking_edit_extra_quantity_item(inputs)
	if (locale === "pt-BR") return pt_br2_admin_external_booking_edit_extra_quantity_item(inputs)
	if (locale === "pl") return pl_admin_external_booking_edit_extra_quantity_item(inputs)
	if (locale === "hu") return hu_admin_external_booking_edit_extra_quantity_item(inputs)
	return ro_admin_external_booking_edit_extra_quantity_item(inputs)
});
export { admin_external_booking_edit_extra_quantity_item as "admin.external_booking_edit.extra_quantity_item" }